
<template>
  <g class="not-copy">
    <!-- 選択時の枠 -->
    <rect fill="transparent" :stroke="cursorColor" stroke-width="3" :stroke-dasharray="cursorDasfArray" :stroke-dashoffset="cursorDasfOffset" :x="scenario.beforenodeX - 5" :y="scenario.beforenodeY - 5" :width="cursorBoxX + 10" :height="cursorBoxY * (scenario.select.length + 1) + 20" :rx="rxSize" v-if="((scenario.status === 0 || scenario.status === 17) && (isMoveScenario))"></rect>
    <rect fill="transparent" :stroke="cursorColor" stroke-width="3" :stroke-dasharray="cursorDasfArray" :stroke-dashoffset="cursorDasfOffset" :x="scenario.beforenodeX - 5" :y="scenario.beforenodeY - 5" :width="cursorBoxX + 10" :height="cursorBoxY * (scenario.select.length) + 10" :rx="rxSize" v-if="((scenario.status === 1 || scenario.status === 2 || scenario.status === 4 || scenario.status === 6 || scenario.status === 7 || scenario.status === 8 || scenario.status === 10 || scenario.status === 13 || scenario.status === 14 || scenario.status === 15 || scenario.status === 16 || scenario.status === 18 || scenario.status === 19 || scenario.status === 20 || scenario.status === 21) && (isMoveScenario))"></rect>
    <rect fill="transparent" :stroke="cursorColor" stroke-width="3" :stroke-dasharray="cursorDasfArray" :stroke-dashoffset="cursorDasfOffset" :x="scenario.beforenodeX - 5" :y="scenario.beforenodeY - 5" :width="cursorBoxX - 45" :height="cursorBoxY * 5.5" :rx="rxSize" v-if="(scenario.status === 3 && isMoveScenario)"></rect>
    <rect fill="transparent" :stroke="cursorColor" stroke-width="3" :stroke-dasharray="cursorDasfArray" :stroke-dashoffset="cursorDasfOffset" :x="scenario.beforenodeX - 5" :y="scenario.beforenodeY - 5" :width="cursorBoxX + 10" :height="cursorBoxY * 4.5" :rx="rxSize" v-if="(scenario.status === 5 && isMoveScenario)"></rect>
    <rect fill="transparent" :stroke="cursorColor" stroke-width="3" :stroke-dasharray="cursorDasfArray" :stroke-dashoffset="cursorDasfOffset" :x="scenario.beforenodeX - 5" :y="scenario.beforenodeY - 5" :width="cursorBoxX - 45" :height="cursorBoxY * (scenario.select.length) + 10" :rx="rxSize" v-if="(scenario.status === 9 && isMoveScenario)"></rect>
    <!-- Node -->
    <rect :fill="bgColorBlue" :x="scenario.beforenodeX" :y="scenario.beforenodeY" :width="nodeSize" :height="nodeSize" :rx="rxSize" @mouseover="saveConnectNode" v-if="!scenario.start_flg && scenario.status!=22 || scenario.input_flg"></rect>
    <circle stroke="#CCC" :fill="bgColorLightBlue" :cx="scenario.beforenodeX + 21" :cy="scenario.beforenodeY + 22.5" :r="startNodeSize" @mouseover="saveConnectNode" v-if="scenario.start_flg && scenario.status!=22 || scenario.input_flg"></circle>
    <text fill="black" font-size="25" v-if="scenario.start_flg" :x="scenario.beforenodeX + 15" :y="scenario.beforenodeY + 30.5">S</text>
    <!-- Message -->
    <rect :fill="bgColorBlue"  :x="Number(scenario.beforenodeX) + 55" :y="scenario.beforenodeY" :width="messageBoxX" :height="messageBoxY" :rx="rxSize" @mousedown="moveScenario"></rect>
    <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="Number(scenario.beforenodeY) + 5" :width="messageX" :height="messageY" :rx="rxSize" @mousedown="moveScenario"></rect>
    <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30" @mousedown="moveScenario" v-if="scenario.status!==3&&scenario.status!==6&&scenario.status!==10&&scenario.status!==13&&scenario.status!==16">{{subMessage(scenario.mainmessage, 13)}}</text>
    <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30" @mousedown="moveScenario" v-if="scenario.status===3">ロボの切替</text>
    <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30" @mousedown="moveScenario" v-if="scenario.status===6">[入力]{{subMessage(scenario.mainmessage, 15)}}</text>
    <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30" @mousedown="moveScenario" v-if="scenario.status===10">[Eメール送付]</text>
    <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30" @mousedown="moveScenario" v-if="scenario.status===13">[チェックボックス]</text>
    <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30" @mousedown="moveScenario" v-if="scenario.status===16">[SMS送付]</text>
    <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30" @mousedown="moveScenario" v-if="scenario.status===100">[パーツセット]</text>
    <template v-if="scenario.select.length > 1 && scenario.status === 4 && scenario.parameter">
      <template v-if="scenario.parameter.is_nothing_target_date">
        <rect @mouseover="overMouse($event, true, subMessage('希望する日程がない', 200))" @mouseleave="overMouse($event, false, null)" :fill="bgColorBlue"  :x="Number(scenario.beforenodeX) + 55" :y="scenario.beforenodeY + 50" :width="messageBoxX" :height="messageBoxY" :rx="rxSize" @mousedown="moveScenario"></rect>
        <rect @mouseover="overMouse($event, true, subMessage('希望する日程がない', 200))" @mouseleave="overMouse($event, false, null)" :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="Number(scenario.beforenodeY) + 5 + 50" :width="messageX" :height="messageY" :rx="rxSize" @mousedown="moveScenario"></rect>
        <text @mouseover="overMouse($event, true, subMessage(scenario.mainmessage, 200))" @mouseleave="overMouse($event, false, null)" :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="Number(scenario.beforenodeY) + 30 + 50" @mousedown="moveScenario">[希望する日程がない]</text>
      </template>
    </template>
    <!-- 選択肢ありメッセージ -->
    <g v-if="scenario.status===0">
      <rect :fill="bgColorBlue"  :x="Number(scenario.beforenodeX) + 55"  :y="Number(scenario.beforenodeY) + 55" :width="selectBoxX" :height="Number(selectBoxY * (scenario.select.length))" :rx="rxSize" @mousedown="moveScenario"></rect>
      <g v-for="(s, i) in scenario.select" :key="i">
        <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60"  :y="Number(scenario.beforenodeY) + (i * 45) + 60" :width="messageX" :height="messageY" :rx="rxSize" @mousedown="moveScenario"></rect>
        <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65"  :y="Number(scenario.beforenodeY) + (i * 45) + 85" @mousedown="moveScenario">{{subMessage(s.message, 13)}}</text>
        <rect :fill="makeColorNodeBox(i)"  :x="Number(scenario.beforenodeX) + 265" :y="Number(scenario.beforenodeY) + (i * 45) + 60" :width="Number(nodeSize - 5)" :height="Number(nodeSize - 5)" :rx="rxSize" @mousedown="lineNode(i, $event)" v-if="!scenario.is_cv"></rect>
        <circle :stroke="bgColorBlue" stroke-width="5" :fill="bgColorLightBlue" :cx="Number(scenario.beforenodeX) + 265 + 21" :cy="Number(scenario.beforenodeY) + (i * 45) + 78.5" :r="startNodeSize*3/4" @mouseover="saveConnectNode" v-if="scenario.is_cv"></circle>
        <text fill="black" font-size="25" v-if="scenario.is_cv" :x="Number(scenario.beforenodeX) + 265 + 12" :y="Number(scenario.beforenodeY) + (i * 45) + 87.5">G</text>
      </g>
    </g>
    <!-- ロボ切り替え -->
    <g v-else-if="scenario.status===3" >
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 55" :y="scenario.beforenodeY + 55" :width="selectBoxX" :height="selectBoxY * 4" :rx="rxSize" @mousedown="moveScenario"></rect>
      <rect :fill="bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="scenario.beforenodeY + 60" :width="selectBoxX - 10" :height="selectBoxY * 3 - 10" :rx="rxSize" @mousedown="moveScenario"></rect>
      <rect :fill="bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="scenario.beforenodeY + 195" :width="selectBoxX - 10" :height="selectBoxY - 10" :rx="rxSize" @mousedown="moveScenario"></rect>
      <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="scenario.beforenodeY + 220" @mousedown="moveScenario" v-if="scenario.status===3">{{subMessage('ロボ名：' + (chatbots.find(bot => bot.bot_id==scenario.parameter.bot_id) ? chatbots.find(bot => bot.bot_id==scenario.parameter.bot_id).name : 'No Name'), 13)}}</text>
      <image :x="Number(scenario.beforenodeX) + 97.5" :y="scenario.beforenodeY + 65" :width="nodeSize * 2.5" :height="nodeSize * 2.5" :xlink:href="makeImage(scenario.parameter)" @mousedown="moveScenario"/>
    </g>
    <!-- 画像 -->
    <g v-else-if="scenario.status===5" >
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 55" :y="scenario.beforenodeY + 55" :width="selectBoxX" :height="selectBoxY * 3" :rx="rxSize" @mousedown="moveScenario"></rect>
      <rect :fill="bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="scenario.beforenodeY + 60" :width="selectBoxX - 10" :height="selectBoxY * 3 - 10" :rx="rxSize" @mousedown="moveScenario"></rect>
      <image :x="Number(scenario.beforenodeX) + 85" :y="scenario.beforenodeY + 65" :width="nodeSize * 3" :height="nodeSize * 2.5" :xlink:href="makeImageScenario(scenario.image)" @mousedown="moveScenario"/>
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 265" :y="scenario.beforenodeY" :width="nodeSize" :height="nodeSize" :rx="rxSize" @mousedown="lineNode(0, $event)"></rect>
    </g>
    <!-- 条件分岐 -->
    <g v-else-if="scenario.status===12">
      <rect :fill="bgColorBlue"  :x="Number(scenario.beforenodeX) + 55"  :y="Number(scenario.beforenodeY) + 55" :width="selectBoxX" :height="Number(selectBoxY * (scenario.parameter.length))" :rx="rxSize" @mousedown="moveScenario"></rect>
      <g v-for="(s, i) in scenario.parameter" :key="i">
        <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60"  :y="Number(scenario.beforenodeY) + (i * 45) + 60" :width="messageX" :height="messageY" :rx="rxSize" @mousedown="moveScenario"></rect>
        <text v-if="s.wordList[0].word === '' && s.wordList[0].terms === '' && s.pointList[0].terms !== ''" :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65"  :y="Number(scenario.beforenodeY) + (i * 45) + 85" @mousedown="moveScenario">{{s.pointList[0].point}}pt{{s.pointList[0].terms}}</text>
        <text v-else-if="s.pointList[0].terms === '' && s.wordList[0].word !== '' && s.wordList[0].terms !== ''" :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65"  :y="Number(scenario.beforenodeY) + (i * 45) + 85" @mousedown="moveScenario">{{subMessage(s.wordList[0].word, 13)}}と/を{{s.wordList[0].terms}}</text>
        <text v-else-if="s.userInfoList && s.userInfoList[0].word !== '' && s.userInfoList[0].terms !== ''" :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65"  :y="Number(scenario.beforenodeY) + (i * 45) + 85" @mousedown="moveScenario">{{subMessage(s.userInfoList[0].word, 13)}}と/を{{s.userInfoList[0].terms}}</text>
        <text v-else-if="s.miniroboVarsList && s.miniroboVarsList[0].word !== '' && s.miniroboVarsList[0].terms !== ''" :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65"  :y="Number(scenario.beforenodeY) + (i * 45) + 85" @mousedown="moveScenario">{{subMessage(s.miniroboVarsList[0].word, 13)}}と/を{{s.miniroboVarsList[0].terms}}</text>
        <text v-else-if="s.random == true" :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65"  :y="Number(scenario.beforenodeY) + (i * 45) + 85" @mouseover="overMouseOther($event, 'ランダム'+ (i + 1))" @mouseleave="overMouseOther($event, null)" @mousedown="moveScenario">ランダム{{i+1}}</text>
        <text v-else :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65"  :y="Number(scenario.beforenodeY) + (i * 45) + 85" @mousedown="moveScenario">条件を設定してください</text>
        <rect :fill="makeColorNodeBox(i)"  :x="Number(scenario.beforenodeX) + 265" :y="Number(scenario.beforenodeY) + (i * 45) + 60" :width="Number(nodeSize - 5)" :height="Number(nodeSize - 5)" :rx="rxSize" @mousedown="lineNode(i, $event)" v-if="!scenario.is_cv"></rect>
        <circle :stroke="bgColorBlue" stroke-width="5" :fill="bgColorLightBlue" :cx="Number(scenario.beforenodeX) + 265 + 21" :cy="Number(scenario.beforenodeY) + (i * 45) + 78.5" :r="startNodeSize*3/4" @mouseover="saveConnectNode" v-if="scenario.is_cv"></circle>
        <text fill="black" font-size="25" v-if="scenario.is_cv" :x="Number(scenario.beforenodeX) + 265 + 12" :y="Number(scenario.beforenodeY) + (i * 45) + 87.5">G</text>
      </g>
    </g>
    <!-- カルーセル -->
    <g v-else-if="scenario.status===17">
      <rect :fill="bgColorBlue"  :x="Number(scenario.beforenodeX) + 55"  :y="Number(scenario.beforenodeY) + 55" :width="selectBoxX" :height="Number(selectBoxY * (Object.keys(scenario.parameter).length))" :rx="rxSize" @mousedown="moveScenario"></rect>
      <g v-for="(s, index, i) in scenario.parameter" :key="index">
        <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60"  :y="Number(scenario.beforenodeY) + (i * 45) + 60" :width="messageX" :height="messageY" :rx="rxSize" @mousedown="moveScenario"></rect>
        <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65"  :y="Number(scenario.beforenodeY) + (i * 45) + 85"  @mousedown="moveScenario" v-if="s.title!=''">{{subMessage(s.title, 13)}}</text>
        <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65"  :y="Number(scenario.beforenodeY) + (i * 45) + 85"  @mousedown="moveScenario" v-else>選択肢{{s.id}}を入力</text>
        <rect :fill="makeColorNodeBox(i)"  :x="Number(scenario.beforenodeX) + 265" :y="Number(scenario.beforenodeY) + (i * 45) + 57.5" :width="Number(nodeSize - 2.5)" :height="Number(nodeSize - 2.5)" :rx="rxSize" @mousedown="lineNode(i, $event)" v-if="!scenario.is_cv"></rect>
        <circle :stroke="bgColorBlue" stroke-width="5" :fill="bgColorLightBlue" :cx="Number(scenario.beforenodeX) + 265 + 21" :cy="Number(scenario.beforenodeY) + (i * 45) + 78.5" :r="startNodeSize*3/4" @mouseover="saveConnectNode" v-if="scenario.is_cv"></circle>
        <text fill="black" font-size="25" v-if="scenario.is_cv" :x="Number(scenario.beforenodeX) + 265 + 12" :y="Number(scenario.beforenodeY) + (i * 45) + 87.5">G</text>
      </g>
    </g>
    <!-- パーツセット -->
    <g v-else-if="scenario.status===100" >
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 55" :y="scenario.beforenodeY + 55" :width="selectBoxX" :height="selectBoxY * 4" :rx="rxSize" @mousedown="moveScenario"></rect>
      <rect :fill="bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="scenario.beforenodeY + 60" :width="selectBoxX - 10" :height="selectBoxY * 3 - 10" :rx="rxSize" @mousedown="moveScenario"></rect>
      <rect :fill="bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="scenario.beforenodeY + 195" :width="selectBoxX - 10" :height="selectBoxY - 10" :rx="rxSize" @mousedown="moveScenario"></rect>
      <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="scenario.beforenodeY + 220" @mousedown="moveScenario">{{subMessage('セット名：' + scenario.parameter['robo_parts_set_name'], 13)}}</text>
      <rect :fill="makeColorBoxNext(0)" :x="Number(scenario.beforenodeX) + 265" :y="scenario.beforenodeY" :width="nodeSize" :height="nodeSize" :rx="rxSize" @mousedown="lineNode(0, $event)"></rect>
      <image :x="Number(scenario.beforenodeX) + 97.5" :y="scenario.beforenodeY + 65" :width="nodeSize * 2.5" :height="nodeSize * 2.5" :xlink:href="makeImage(null)" @mousedown="moveScenario"/>
    </g>
    <!-- その他 -->
    <g v-else-if="scenario.status===1 || scenario.status===2 || scenario.status===4 || scenario.status===6 || scenario.status===7 || scenario.status===8 || scenario.status===10 || scenario.status===13 || scenario.status===14 || scenario.status===15 || scenario.status===16 || scenario.status===18 || scenario.status===19 || scenario.status === 20 || scenario.status === 21">
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 265" :y="scenario.beforenodeY" :width="nodeSize" :height="nodeSize" :rx="rxSize" @mousedown="lineNode(0, $event)" v-if="!scenario.is_cv"></rect>
      <template v-if="scenario.select.length > 1 && scenario.status === 4 && scenario.parameter">
        <template v-if="scenario.parameter.is_nothing_target_date">
          <rect :fill="makeColorBoxNext(1)" :x="Number(scenario.beforenodeX) + 265" :y="scenario.beforenodeY + 50" :width="nodeSize" :height="nodeSize" :rx="rxSize" @mousedown="lineNode(1, $event)" v-if="!scenario.is_cv"></rect>
        </template>
      </template>
      <circle :stroke="bgColorBlue" stroke-width="5" :fill="bgColorLightBlue" :cx="Number(scenario.beforenodeX) + 265 + 21" :cy="scenario.beforenodeY + 22.5" :r="startNodeSize" @mouseover="saveConnectNode" v-if="scenario.is_cv || scenario.output_flg"></circle>
      <text fill="black" font-size="25" v-if="scenario.is_cv" :x="Number(scenario.beforenodeX) + 265 + 12" :y="scenario.beforenodeY + 31">G</text>
    </g>
    <!-- Switching Chatbot -->
    <g v-else-if="scenario.status===3" >
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 55" :y="scenario.beforenodeY + 55" :width="selectBoxX" :height="selectBoxY * 4" :rx="rxSize" @mousedown="moveScenario"></rect>
      <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="scenario.beforenodeY + 60" :width="selectBoxX - 10" :height="selectBoxY * 3 - 10" :rx="rxSize" @mousedown="moveScenario"></rect>
      <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="scenario.beforenodeY + 195" :width="selectBoxX - 10" :height="selectBoxY - 10" :rx="rxSize" @mousedown="moveScenario"></rect>
      <text :fill="bgColorFont"  :x="Number(scenario.beforenodeX) + 65" :y="scenario.beforenodeY + 220" @mousedown="moveScenario" v-if="scenario.status===3">{{subMessage('ロボ名：' + (chatbots.find(bot => bot.bot_id==scenario.parameter.bot_id) ? chatbots.find(bot => bot.bot_id==scenario.parameter.bot_id).name : 'No Name'), 13)}}</text>
      <image :x="Number(scenario.beforenodeX) + 97.5" :y="scenario.beforenodeY + 65" :width="nodeSize * 2.5" :height="nodeSize * 2.5" :xlink:href="makeImage(scenario.parameter)" @mousedown="moveScenario"/>
    </g>
    <!-- Image -->
    <g v-else-if="scenario.status===5" >
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 55" :y="scenario.beforenodeY + 55" :width="selectBoxX" :height="selectBoxY * 3" :rx="rxSize" @mousedown="moveScenario"></rect>
      <rect :fill="scenario.is_confirm ? bgColorGray:bgColorWhite" :x="Number(scenario.beforenodeX) + 60" :y="scenario.beforenodeY + 60" :width="selectBoxX - 10" :height="selectBoxY * 3 - 10" :rx="rxSize" @mousedown="moveScenario"></rect>
      <image :x="Number(scenario.beforenodeX) + 85" :y="scenario.beforenodeY + 65" :width="nodeSize * 3" :height="nodeSize * 2.5" :xlink:href="makeImageScenario(scenario.image)" @mousedown="moveScenario"/>
      <rect :fill="makeColorNodeBox(0)" :x="Number(scenario.beforenodeX) + 265" :y="scenario.beforenodeY" :width="nodeSize" :height="nodeSize" :rx="rxSize" @mousedown="lineNode(0, $event)"></rect>
    </g>
    <path :d="path" fill="none" :stroke="strokeFill" :opacity="strokeOpacity" :stroke-width="strokeWidth" stroke-linecap="round" v-if="path !== '' && isLineNode"/>
  </g>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import hex2rgb from '@/functions/hex2rgb'
import alterReplace from '@/functions/alterStrReplace'
import makeUpdateTemplateData from '@/functions/makeUpdateTemplateData'

export default {
  name: 'ScenarioGroup',
  componentName: 'ScenarioGroup',
  props: ['scenario', 'ratio', 'dx', 'dy', 'step'],
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'chatbots', 'scenarioName', 'isSCNLoading', 'modalScenario', 'isConnecting', 'scenarioNodeData', 'nextNode', 'isRoboPartsSetView', 'selectScenarioList', 'selectStore', 'edit_index', 'selectTemplateId']),
    ...mapState('auth', ['botstatus', 'user']),
    isMoveScenario () {
      if (!this.selectStore['edit_list']) return false
      else if (!this.selectStore.edit_list[this.step]) return false
      else if (this.selectStore.edit_list[this.step].scenario.beforenode == this.scenario.beforenode) return true
    }
  },
  components: {
    alterReplace
  },
  data () {
    return {
      isMinimumDescription: false,
      isLineNode: false,
      beforeMouseX: null,
      beforeMouseY: null,
      bgColorWhite: '#f8f8f8',
      bgColorLightBlue: '#ccfff2',
      bgColorMidBlue: '#65ffd8',
      bgColorBlue: '#00cb98',
      bgColorGray: '#c0c0c0',
      bgColorYellowList: ['#00cb98', '#CCFFCC'],
      startColorSetting: '#00cb98',
      bgColorFont: '#000',
      nodeSize: 45,
      startNodeSize: 25,
      rxSize: 5,
      fontSize: '12px',
      cursorBoxX: 310,
      cursorBoxY: 45,
      cursorColor: '#550011',
      cursorDasfOffset: 0,
      cursorDasfArray: 5,
      messageBoxX: 200,
      messageBoxY: 45,
      messageX: 190,
      messageY: 35,
      selectBoxX: 200,
      selectBoxY: 45,
      selectX: 190,
      selectY: 35,
      moveLineX: 0,
      moveLineY: 0,
      startLineX: 0,
      startLineY: 0,
      path: '',
      strokeWidth: '3',
      strokeFill: '#000',
      strokeOpacity: 0.5,
      isMouseout: false
    }
  },
  mounted () {
    console.debug('*** Start *** mounted')
    document.addEventListener('mouseup', this.mouseUp)
    document.addEventListener('mousemove', this.mouseMove)
    for (var i in this.selectScenarioList) {
      if (this.selectScenarioList[i].scenario.beforenode == this.scenario.beforenode) {
        this.isMoveScenario = true
        this.bgColorBlue = '#661111'
      }
    }
    console.debug('*** End *** mounted')
  },
  beforeDestroy () {
    console.debug('*** Start *** beforeDestroy')
    document.removeEventListener('mouseup', this.mouseUp)
    document.removeEventListener('mousemove', this.mouseMove)
    console.debug('*** End *** beforeDestroy')
  },
  methods: {
    select (scenario) {
      console.debug('*** Start *** select')
      console.debug('scenario: ' + JSON.stringify(scenario))
      if (scenario.status == 3 || scenario.status == 7 || scenario.status == 8 || scenario.status == 9) alert('このシナリオは変更できません。')
      else {
        this.isMoveScenario = !this.isMoveScenario
        // this.$store.dispatch('chatbot/selectScenario', scenario)
        this.$store.dispatch('chatbot/selectScenarioList', {flg: this.isMoveScenario, scenario: scenario})
      }
      console.debug('*** End *** select')
    },
    mouseOut (event) {
      console.debug('*** Start *** select')
      console.debug('event: ' + JSON.stringify(event))
      this.isMouseout = true
      console.debug('*** End *** select')
    },
    makeColorNodeBox (i) {
      console.debug('*** Start *** makeColorNodeBox')
      console.debug('i: ' + JSON.stringify(i))
      if (this.isLineNode && Object.keys(this.scenarioNodeData).length === 1) {
        if (this.scenarioNodeData[0].select[this.nextNode].next_node === this.scenario.select[i].next_node && this.nextNode === i) return '#f00'
        else return this.bgColorBlue
      }
      else return this.bgColorBlue
    },
    makeImage (parameter) {
      for (const bot of this.chatbots) {
        if (parameter.bot_id === bot.bot_id) {
          if (bot.icon_data) return bot.icon_data
        }
        for (const mini of bot.chatbot_mini) {
          if (parameter.bot_id === mini.bot_id) {
            if (mini.icon_data) return mini.icon_data
          }
        }
      }
      return require('../../../assets/template/robot.png')
    },
    makeImageScenario (img) {
      console.debug('*** Start *** makeImageScenario')
      console.debug('img: ' + JSON.stringify(img))
      if (img != '') return img
      else return require('@/assets/template/no_image.svg')
      console.debug('*** End *** makeImageScenario')
    },
    makeStart () {
      console.debug('*** Start *** makeStart')
      return 'M' + this.scenario.beforenodeX + ',' + this.scenario.beforenodeY + this.startFig
    },
    startColor () {
      console.debug('*** Start *** startColor')
      if (this.scenario.start_flg) return this.bgColorYellow
      else return this.bgColorBlue
    },
    curve (node) {
      console.debug('*** Start *** curve')
      console.debug('node: ' + JSON.stringify(node))
      const qx1 = (node.start.x + node.end.x) / 2
      const qy1 = (node.start.y + node.end.y) / 2
      const qx2 = ((node.start.x + node.end.x) / 2 + node.start.x) / 2
      const amplitude = (node.end.y - node.start.y) / 4
      const qy2 = (node.start.y + node.end.y) / 2 + amplitude
      this.path = 'M' + node.start.x + ',' + node.start.y + ' Q' + qx2 + ',' + qy2 + ' ' + qx1 + ',' + qy1 + ' T' + node.end.x + ',' + node.end.y
      console.debug('*** End *** curve')
    },
    subMessage (m, num) {
      console.debug('*** Start *** subMessage')
      console.debug('m: ' + JSON.stringify(m))
      console.debug('num: ' + JSON.stringify(num))
      m = m ? alterReplace(m, true) : m
      // 応募フォーム以外
      // alert(m)
      if (m.indexOf('[calendar]') !== -1) {
        console.info('Automatic schedule adjustment')
        return '日程自動調整'
      } else if (this.scenario.status === 1) {
        console.info('Application Form')
        return '応募フォーム'
      } else if (m.indexOf('[fileupload][/fileupload]') !== -1) {
        console.info('File upload')
        return 'ファイルアップロード'
      } else if (m.indexOf('[image][/image]') !== -1) {
        console.info('Image display')
        return '画像表示'
      } else if (m.indexOf('[input]') !== -1 && m.indexOf('[/input]') !== -1) {
        console.info('not input snd /imput')
        var w = m.replace('[input]', '').replace('[/input]', '')
        if (w[0] == null) return w[0]
        else return w[0] < num ? w : w[0].substring(0, num - 3) + '...'
      } else if (m.indexOf('[resume][/resume]') !== -1) {
        console.info('Resume form')
        return '履歴書フォーム'
      }
      else if (m.indexOf('[restart][/restart]' !== -1) && this.scenario.status === 9) {
        console.info('Return to the beginning')
        return '最初に戻る'
      }
      else if (m.indexOf('[checkbox]') !== -1 && m.indexOf('[/checkbox]') !== -1 && this.scenario.status === 13) {
        return 'チェックボックス'
      }
      else if (m.indexOf('[movie][/movie]') !== -1) {
        return '動画を再生する'
      }
      else if (m.indexOf('[pulldown]') !== -1 && m.indexOf('[/pulldown]') !== -1 && this.scenario.status === 15) {
        return 'プルダウン選択'
      }
      else if (m.indexOf('[carousel][/carousel]') !== -1) {
        return 'カルーセル選択肢'
      }
      else if (m.indexOf('[filedownload]') !== -1 && m.indexOf('[/filedownload]') !== -1 && this.scenario.status === 18) {
        return 'ファイルダウンロード'
      }
      else if (m.indexOf('[output]') !== -1 && m.indexOf('[/output]') !== -1 && this.scenario.status === 19) {
        return '回答出力'
      }
      else if (m.indexOf('[search]') !== -1 && m.indexOf('[/search]') !== -1 && this.scenario.status === 20) {
        return '検索パーツ'
      }
      else if (m.indexOf('[pdf-download]') !== -1 && m.indexOf('[/pdf-download]') !== -1 && this.scenario.status === 21) {
        return 'PDFダウンロード'
      }
      else {
        console.info('else')
        m = m.replace('[memo]', '').replace('[/memo]', '')
        if (m.indexOf('\n') === -1) return m.length < num ? m : m.substring(0, num - 3) + '...'
        else {
          var w = m.split('\n')
          return w[0] < num ? m : w[0].substring(0, num - 3) + '...'
        }
      }
    },
    moveScenario (event) {
      console.debug('*** Start *** moveScenario')
      console.debug('event: ' + JSON.stringify(event))
      event.preventDefault()
      // this.isMoveScenario = true
      this.$store.dispatch('chatbot/setPathScenario', this.scenario)
      console.debug('*** End *** moveScenario')
    },
    saveConnectNode (event) {
      console.debug('*** Start *** saveConnectNode')
      console.debug('event: ' + JSON.stringify(event))
      // console.log('PUTPUT Connect MOUSEOVER: ' + this.isConnecting + ', ' + this.isLineNode + ', ' + JSON.stringify(this.scenario))
      if (this.isConnecting&&!this.isLineNode) this.$store.dispatch('chatbot/changeIsConnecting', {flg: true, scenario: this.scenario})
      event.preventDefault()
      console.debug('*** End *** saveConnectNode')
    },
    lineNode (i, event) {
      console.debug('*** Start *** saveConnectNode')
      console.debug('i: ' + i)
      console.debug('event: ' + JSON.stringify(event))
      // console.log('PUTPUT LINENODE: ' + event.offsetX + ',' + event.offsetY)
      // console.log('PUTPUT LINENODE lineNode: ' + i + ',' + event.offsetY)
      this.startLineX = event.offsetX * this.ratio + this.dx
      this.startLineY = event.offsetY * this.ratio + this.dy
      this.moveLineX = event.offsetX * this.ratio + this.dx
      this.moveLineY = event.offsetY * this.ratio + this.dy
      this.isLineNode = true
      this.$store.dispatch('chatbot/saveNextNode', i)
      this.$store.dispatch('chatbot/changeIsConnecting', {flg: true, scenario: this.scenario})
      event.preventDefault()
      console.debug('*** End *** saveConnectNode')
    },
    mouseUp (event) {
      console.debug('*** Start *** mouseUp')
      console.debug('event: ' + JSON.stringify(event))
      if (Object.keys(this.scenarioNodeData).length > 1) {
        console.info('SAVE NODE Connect status MOUSEOVER: ' + Object.keys(this.scenarioNodeData).length + ',' + JSON.stringify(this.scenarioNodeData))
        var s = this.scenarioNodeData[0]
        s.select[this.nextNode].next_node = this.scenarioNodeData[1].beforenode
        console.info('SAVE NODE Connect status MOUSEOVER s: ' + JSON.stringify(s))
        this.$store.dispatch('chatbot/setScenario', { companyid: this.user.companyID, scenarioName: this.scenario.name, scenario: s})
      }
      this.$store.dispatch('chatbot/changeIsConnecting', {flg: false, scenario: this.scenario})
      this.$store.dispatch('chatbot/setPathScenario', null)
      // this.isMoveScenario = false
      this.isLineNode = false
      this.beforeMouseX = null
      this.beforeMouseY = null
      this.path = ''
      this.isMouseout = false
      event.preventDefault()
      console.debug('*** End *** mouseUp')
    },
    // mouseMove (event) {
    //   if (!this.isMoveScenario && !this.isLineNode) return
    //   var mouseX = event.offsetX * this.ratio + this.dx
    //   var mouseY = event.offsetY * this.ratio + this.dy
    //   var dx = 0
    //   var dy = 0
    //   if (this.beforeMouseX && this.beforeMouseY) {
    //       dx = mouseX - this.beforeMouseX
    //       dy = mouseY - this.beforeMouseY
    //   }
    //   this.beforeMouseX = mouseX
    //   this.beforeMouseY = mouseY
    //   var tempX = 0
    //   var tempY = 0
    //   // 動かす場合
    //   if (this.isMoveScenario) {
    //     tempX = dx + Number(this.scenario.beforenodeX)
    //     tempY = dy + Number(this.scenario.beforenodeY)
    //     if (tempX > 0 && !this.isMouseout) this.scenario.beforenodeX = tempX
    //     if (tempY > 0 && !this.isMouseout) this.scenario.beforenodeY = tempY
    //   }
    //   // 線を引く場合
    //   if (this.isLineNode) {
    //     tempX = this.moveLineX
    //     tempY = this.moveLineY
    //     tempX += dx
    //     tempY += dy
    //     if (tempX > 0) this.moveLineX = tempX
    //     if (tempY > 0) this.moveLineY = tempY
    //     // console.log('testtest2 curve: ' + this.startLineX + ', ' + this.startLineY + ', ' + this.moveLineX + ', ' + this.moveLineY + ', ' + dx + ', ' + dy)
    //     this.curve({
    //       start: {
    //         x: this.startLineX,
    //         y: this.startLineY
    //       },
    //       end: {
    //         x: this.moveLineX,
    //         y: this.moveLineY
    //       }
    //     })
    //   }
    //   event.preventDefault()
    // },
    openContextMenu (event) {
      console.debug('*** Start *** openContextMenu')
      console.debug('event: ' + JSON.stringify(event))
      // if (this.isLineNode || this.isMoveScenario) {
        var menu = document.getElementById("context-menu")
        if(!this.contextMenuWidth || !this.contextMenuHeight) {
          menu.style.visibility = 'hidden'
          menu.style.display = 'block'
          this.contextMenuWidth = menu.offsetWidth
          this.contextMenuHeight = menu.offsetHeight
          menu.removeAttribute('style')
        }
        var tepmViewY = 0
        if (this.isRoboPartsSetView){
          tepmViewY = 50
        }
        if((this.contextMenuWidth + event.pageX) >= window.innerWidth) {
          menu.style.left = (event.pageX - this.contextMenuWidth) + 'px'
        } else {
          menu.style.left = event.pageX + 'px'
        }
        if((this.contextMenuHeight + event.pageY) >= window.innerHeight) {
          menu.style.top = (event.pageY - this.contextMenuHeight) + tepmViewY + 'px'
        } else {
          menu.style.top = event.pageY + tepmViewY + 'px'
        }
        menu.classList.add('active')
        this.$store.dispatch('chatbot/selectScenario', this.scenario)
      // }
      console.debug('*** End *** openContextMenu')
    },
    closeContextMenu () {
      console.debug('*** Start *** closeContextMenu')
      document.getElementById('context-menu').classList.remove('active')
      console.debug('*** End *** closeContextMenu')
    }
  }
}
</script>

<style scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ScenarioGroupEdit.vue